export default __webpack_public_path__ + "static/media/TirthankarRoy.2726dab5.png";